import React, { useMemo } from 'react';
import { DocumentCardItem } from './DocumentCardItem';
import { FileTypeEnum, SimulationDocumentDto } from 'api/documents';
import { EmailConfig } from '../../types/emailConfig';

interface DocumentsListProps {
  documents: SimulationDocumentDto[];
  isFetchingDocuments: boolean;
  isSendingContract: boolean;
  emailConfig?: EmailConfig;
}

export const DocumentsList: React.FC<DocumentsListProps> = ({
  documents,
  isFetchingDocuments,
  isSendingContract,
  emailConfig
}) => {
  const renderDocuments = useMemo(() => {
    return documents.map((doc, index) => {
      let loading = isFetchingDocuments;
      if (doc.fileType === FileTypeEnum.BulletinAdhesion && isSendingContract) {
        loading = true;
      }

      return (
        <DocumentCardItem
          key={`${doc.fileType}-${index}`}
          simulationDoc={doc}
          isLoading={loading}
          emailConfig={emailConfig}
        />
      );
    });
  }, [documents, isFetchingDocuments, isSendingContract, emailConfig]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-stretch">
      {renderDocuments}
    </div>
  );
};
